export default __webpack_public_path__ + "static/media/how-to-deposit-local-bank-in-video.62dc0a72.mp4";